import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-magnifier',
  templateUrl: './icon-magnifier.component.html',
  styleUrls: ['./icon-magnifier.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconMagnifierComponent {}
